import format from "date-fns/format";
import React, { useEffect, useState } from "react";
import { BILL_GROUP_DATE_FORMAT } from "utils/constants";

import { BillItem } from "./BillItem";

type BillListItemProps = {
  billAttributes: BillAttributes;
  id: string;
  labelDisplayIds: {
    [x: string]: string;
  };
  setLabelDisplayIds: (value: { [x: string]: string }) => void;
};

/**
 * @description An item with the details of a bill row.
 */
const BillListItem: React.FC<BillListItemProps> = ({
  billAttributes,
  id,
  labelDisplayIds,
  setLabelDisplayIds,
}) => {
  const [showMonth, setShowMonth] = useState(true);

  const billMonthYear = format(
    new Date(billAttributes.billing_period.period_started_at),
    BILL_GROUP_DATE_FORMAT,
  );

  /*
   Bills are grouped by month with a label (eg January 2023) at the top of each group
   this section determines if a label is needed or already present by:
   checking for each Bill if labelDisplayIds already has the same month recorded:
     a. if yes check if the relevant id recorded with the month is the same as the bill's id.
        If yes then display the label, if no then do not display label
     b. if no then it is the first bill associated with a new month, so record the month and bill id
        into labelDisplayIds
    ex: labelDisplayIds = { "Jan 02, 2023" : "12ncded",  "Feb 03, 2023 " : "321cs"... }
   */
  useEffect(() => {
    if (
      labelDisplayIds[billMonthYear] &&
      labelDisplayIds[billMonthYear] !== id
    ) {
      setShowMonth(false);
    }
    if (!labelDisplayIds[billMonthYear]) {
      const newValue = labelDisplayIds;
      newValue[billMonthYear] = id;
      setLabelDisplayIds(newValue);
    }
  }, [labelDisplayIds]);

  return (
    <>
      {showMonth && (
        <li className="customer_tools_list__title">{billMonthYear}</li>
      )}

      <li className="customer_tools_list__item">
        <BillItem bill={billAttributes} componentTitle={"Bills"} />
      </li>
    </>
  );
};

type BillListProps = {
  bills: Bill[];
};

/**
 * @description A list of bill rows sorted by date.
 */
export const BillList: React.FC<BillListProps> = ({ bills }) => {
  const [labelDisplayIds, setLabelDisplayIds] = useState({});

  return (
    <>
      {bills.map((bill) => {
        return (
          <BillListItem
            key={bill.id}
            billAttributes={bill.attributes}
            id={bill.id}
            labelDisplayIds={labelDisplayIds}
            setLabelDisplayIds={setLabelDisplayIds}
          />
        );
      })}
    </>
  );
};
